import { render } from "./CheckboxBox.vue?vue&type=template&id=71fa1369&scoped=true"
import script from "./CheckboxBox.vue?vue&type=script&lang=js"
export * from "./CheckboxBox.vue?vue&type=script&lang=js"

import "./CheckboxBox.vue?vue&type=style&index=0&id=71fa1369&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fa1369"]])

export default __exports__